// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TaskInfo-module__taskInfo--Zc8aq {
    display: flex;
    flex-direction: column;
    margin-top: 30px;
    padding: 15px 20px;
    border-radius: 14px;
    -webkit-box-shadow: -1px 5px 22px 2px rgba(34, 60, 80, 0.11);
    -moz-box-shadow: -1px 5px 22px 2px rgba(34, 60, 80, 0.11);
    box-shadow: -1px 5px 22px 2px rgba(34, 60, 80, 0.11);
    gap: 15px;
    min-height: 40vh;
    background-color: white;
    overflow: hidden;
}

.TaskInfo-module__infoBox--_jO1z {
    margin-top: 20px;
    border-bottom: 1px solid #6f879c4b;
}

.TaskInfo-module__contentRow--ccEIS {
    display: flex;
    gap: 40px;
}

.TaskInfo-module__contentRow--ccEIS:not(:first-child) {
    margin-top: 20px;
}

.TaskInfo-module__contentColumn--Na22Y {
    display: flex;
    flex-direction: column;
    width: 280px;
}

.TaskInfo-module__contentColumn--Na22Y>span {
    color: #6F879C;
    font-size: 16px;
    border-bottom: 1px solid #6f879c4b;
}

.TaskInfo-module__contentColumn--Na22Y>p {
    font-weight: 500;
    color: #516372;
    margin-top: 5px;
    font-size: 18px;
}

.TaskInfo-module__btnBoxChangeStatus--Gfbnb {
    display: flex;
    gap: 20px;
    justify-content: center;
    margin-top: 20px;
}

.TaskInfo-module__formMessage--v1c30 {
    border-radius: 14px;
    -webkit-box-shadow: -2px 9px 18px 5px rgba(34, 60, 80, 0.2);
    -moz-box-shadow: -2px 9px 18px 5px rgba(34, 60, 80, 0.2);
    box-shadow: -2px 9px 18px 5px rgba(34, 60, 80, 0.2);
    min-height: 50px;
    padding: 20px;
}

.TaskInfo-module__inputBox--Uzrd3 {
    display: flex;
    flex-direction: row;
    gap: 10px;
    align-items: center;
    justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/features/task/ui/TaskInfo.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,4DAA4D;IAC5D,yDAAyD;IACzD,oDAAoD;IACpD,SAAS;IACT,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,2DAA2D;IAC3D,wDAAwD;IACxD,mDAAmD;IACnD,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,uBAAuB;AAC3B","sourcesContent":[".taskInfo {\r\n    display: flex;\r\n    flex-direction: column;\r\n    margin-top: 30px;\r\n    padding: 15px 20px;\r\n    border-radius: 14px;\r\n    -webkit-box-shadow: -1px 5px 22px 2px rgba(34, 60, 80, 0.11);\r\n    -moz-box-shadow: -1px 5px 22px 2px rgba(34, 60, 80, 0.11);\r\n    box-shadow: -1px 5px 22px 2px rgba(34, 60, 80, 0.11);\r\n    gap: 15px;\r\n    min-height: 40vh;\r\n    background-color: white;\r\n    overflow: hidden;\r\n}\r\n\r\n.infoBox {\r\n    margin-top: 20px;\r\n    border-bottom: 1px solid #6f879c4b;\r\n}\r\n\r\n.contentRow {\r\n    display: flex;\r\n    gap: 40px;\r\n}\r\n\r\n.contentRow:not(:first-child) {\r\n    margin-top: 20px;\r\n}\r\n\r\n.contentColumn {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 280px;\r\n}\r\n\r\n.contentColumn>span {\r\n    color: #6F879C;\r\n    font-size: 16px;\r\n    border-bottom: 1px solid #6f879c4b;\r\n}\r\n\r\n.contentColumn>p {\r\n    font-weight: 500;\r\n    color: #516372;\r\n    margin-top: 5px;\r\n    font-size: 18px;\r\n}\r\n\r\n.btnBoxChangeStatus {\r\n    display: flex;\r\n    gap: 20px;\r\n    justify-content: center;\r\n    margin-top: 20px;\r\n}\r\n\r\n.formMessage {\r\n    border-radius: 14px;\r\n    -webkit-box-shadow: -2px 9px 18px 5px rgba(34, 60, 80, 0.2);\r\n    -moz-box-shadow: -2px 9px 18px 5px rgba(34, 60, 80, 0.2);\r\n    box-shadow: -2px 9px 18px 5px rgba(34, 60, 80, 0.2);\r\n    min-height: 50px;\r\n    padding: 20px;\r\n}\r\n\r\n.inputBox {\r\n    display: flex;\r\n    flex-direction: row;\r\n    gap: 10px;\r\n    align-items: center;\r\n    justify-content: center;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"taskInfo": `TaskInfo-module__taskInfo--Zc8aq`,
	"infoBox": `TaskInfo-module__infoBox--_jO1z`,
	"contentRow": `TaskInfo-module__contentRow--ccEIS`,
	"contentColumn": `TaskInfo-module__contentColumn--Na22Y`,
	"btnBoxChangeStatus": `TaskInfo-module__btnBoxChangeStatus--Gfbnb`,
	"formMessage": `TaskInfo-module__formMessage--v1c30`,
	"inputBox": `TaskInfo-module__inputBox--Uzrd3`
};
export default ___CSS_LOADER_EXPORT___;
